import { useDisclosure } from "@mantine/hooks";
import { TblDMBarcodeStatus } from "../../../model/BarcodeStatus";
import { useForm } from "@mantine/form";
import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  TextInput,
} from "@mantine/core";
import { handleKeyDown } from "../../../_base/helper/FunctionHelper";
import { sky_blue } from "../../../const/variables";
import { IconCheck, IconWindow } from "@tabler/icons-react";
import { modals } from "@mantine/modals";
import { useEffect } from "react";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";

type EditItemViewProps = { id: string; onClose: any };
export const EditItemView = ({ id, onClose }: EditItemViewProps) => {
  const entity: TblDMBarcodeStatus = {
    id: "0",
    maTtmv: "",
    tenTtmv: "",
    ksd: false,
    isMacDinhNhapMua: false,
    maCty: "",
    createBy: 0,
    createDate: null,
    lastUpdateBy: 0,
    lastUpdateDate: null,
  };
  const [visible, { toggle, close, open }] = useDisclosure(false);
  const form = useForm<TblDMBarcodeStatus>({
    mode: "controlled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      maTtmv: (value: string | null | undefined) => {
        if (!value) return "Mã trạng thái mã vạch không được bỏ trống";
      },
      tenTtmv: (value: string | null | undefined) => {
        if (!value) return "Tên trạng thái mã vạch không được bỏ trống";
      },
      maCty: (value: string | null | undefined) => {
        if (!value) return "Mã công ty không được bỏ trống";
      },
    },
  });
  const callApiGetData = async () => {
    open();
    const callapi = await repositoryMdm.get<
      MessageResponse<TblDMBarcodeStatus>
    >(`/api/v1/BarcodeStatus/get-by-id?id=${id}`);
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
      close();
    } else {
      modals.closeAll();
    }
  };
  const handleEdit = async (dataSubmit: TblDMBarcodeStatus) => {
    open();
    const dataApi = await repositoryMdm.post<
      MessageResponse<TblDMBarcodeStatus>
    >("/api/v1/BarcodeStatus/update", dataSubmit);

    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
    }
    close();
  };

  useEffect(() => {
    if (id) {
      callApiGetData();
    }
  }, [id]);
  return (
    <>
      <Box
        component="form"
        mx="auto"
        onSubmit={form.onSubmit((e: TblDMBarcodeStatus) => {
          handleEdit(e);
        })}
        style={{ position: "relative" }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />

        <Grid mt={10}>
          <Grid.Col span={12}>
            <TextInput
              label={"Mã trạng thái mã vạch"}
              placeholder={"Nhập mã trạng thái mã vạch"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("maTtmv")}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label={"Tên trạng thái mã vạch"}
              placeholder={"Nhập tên mã trạng thái mã vạch"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("tenTtmv")}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <Checkbox
              label={"Không sử dụng"}
              {...form.getInputProps("ksd")}
              checked={form.values.ksd ?? false}
            />
          </Grid.Col>
          <Grid.Col span={6}>
            <Checkbox
              label={"Mặc định nhập/mua"}
              {...form.getInputProps("isMacDinhNhapMua")}
              checked={form.values.isMacDinhNhapMua ?? false}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <TextInput
              label={"Mã công ty"}
              placeholder={"Nhập mã công ty"}
              type="text"
              withAsterisk
              onKeyDown={handleKeyDown}
              {...form.getInputProps("maCty")}
            />
          </Grid.Col>
        </Grid>

        <Group
          justify="end"
          mt="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="button"
            color="gray"
            loading={visible}
            onClick={() => {
              modals.closeAll();
            }}
            leftSection={!visible ? <IconWindow size={18} /> : undefined}
          >
            Đóng
          </Button>
          <Button
            type="submit"
            color={sky_blue.base}
            loading={visible}
            leftSection={!visible ? <IconCheck size={18} /> : undefined}
          >
            Lưu
          </Button>
        </Group>
      </Box>
    </>
  );
};
